module.exports = __webpack_public_path__ + "media/img/x-icon-ruby-2636fb0a.png";